import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import useFetch from "../../../utils/useFetch";
import axios from "../../../utils/fvAxios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import GetfVDateFormate from "../../../utils/Genaricfunctions";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { getOrgType } from "../../../utils/Token";
import moment from "moment";

export default function EditEmployeeTraing({
  userid,
  isMoodleEmployee,
  close,
  userdetails,
  fvuserid,
  setResh,
  refe

}) {
  const [fieldData, setFieldData] = useState({
    field1: userdetails?.firstname,
    field2: userdetails?.lastname,
    field3: userdetails?.fvusername,
    title: userdetails?.title,
  });

  const handleChange = (event) => {
    const { name, value } = event?.target;
    setFieldData((prevData) => ({ ...prevData, [name]: value }));
  };

  const [getEmployeeQuizCategorie, setGetEmployeeQuizCategorie] =
    React.useState([]);

  const [data, setData] = React.useState([]);
  const Save = () => {
    const defaultAttachmentsLists = getEmployeeQuizCategorie?.map((r) => {
      return {
        empQuizCategoryId: r?.empQuizCategoryId,
        categoryName: r?.categoryName,
        categoryType: r?.categoryType,
        subCategoryControlType: r?.subCategoryControlType,
        subCategoriesValue: r?.subCategoriesValue,
        subCategoryEnteredDate: r?.subCategoryEnteredDate ?  moment(r?.subCategoryEnteredDate)?.utc() : null,
        subCategorySelectedValue: r?.subCategorySelectedValue,
        sysUserOrgId: r?.sysUserOrgId,
        sysUserOrgQuizId: r?.sysUserOrgQuizId,
      };
    });

    const data = {
      firstName: fieldData?.field1,
      lastName: fieldData?.field2,
      userName: fieldData?.field3,
      title: fieldData?.title,
      userId: userdetails?.fvuserid,
      employeeCategories: defaultAttachmentsLists,
    };

    const Default = JSON.stringify(defaultAttachmentsLists);
    axios
      .post(
        "Employee/SaveEmployeeDetails",
        data,

        {
          headers: { "Content-Type": "application/json" },
        }
      )
      .then((res) => {
        if (res?.data?.data == "Success") {
          toast.success(res?.data?.responseMessage, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setTimeout(() => {
            setResh(!refe);
          }, 2000);
        } else {
          toast.error(res?.data?.data, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
    close();
  };

  const handleSubCategoryChange = (event, index, property) => {
    const newData = [...data];
    newData[index][property] = event?.target?.value;

    // check if subCategoryEnteredDate has a value
    if (newData[index].subCategoryEnteredDate) {
      const enteredDate = new Date(newData[index]?.subCategoryEnteredDate);
      newData[index].subCategoryEnteredDate = enteredDate;
      // assign the enteredDate as the default value for DatePicker
      newData[index].defaultDate = enteredDate;
    } else {
      newData[index].defaultDate = null;
    }

    setData(newData);
    setGetEmployeeQuizCategorie(data);
  };
  const { data: res } = useFetch(
    "Employee/GetEmployeeCategories?userid=" + fvuserid
  );
  const [spinner, setSpinner] = React.useState(true);
  useEffect(() => {

    if (res?.data) {
      setData(res?.data);
      setSpinner(false)
    }
  }, [res]);
  return (
    <>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={spinner}
      // onClick={SpinnerClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ToastContainer />
      <DialogTitle id="alert-dialog-title">
        {getOrgType() != "Admin"?"Employee Categories":"Edit Employee"}
      </DialogTitle>

      <DialogContent>
        <div  style={{  display:getOrgType() != "Admin"?"none":""}}>
        <span
          style={{
            color: "#3E4A62",
            fontSize: "14px",
            fontWeight: "500",
            marginTop: "5px",
            marginBottom: "5px",
            display:getOrgType() != "Admin"?"none":""
          }}
    
        >
          First Name
        </span>
        <br />
        <TextField
          name="field1"
          sx={{ width: "281px", display:getOrgType() != "Admin"?"none":"" }}
          size="small"
          variant="outlined"
          value={fieldData?.field1}
          onChange={handleChange}
     
        />
        <br />
        <span
          style={{
            color: "#3E4A62",
            fontSize: "14px",
            fontWeight: "500",
            marginTop: "5px",
            marginBottom: "5px",
            display:getOrgType() != "Admin"?"none":""
          }}
    
        >
          Last Name
        </span>
        <br />
        <TextField
          name="field2"
          sx={{ width: "281px", display:getOrgType()  != "Admin"?"none":""}}
          size="small"
          variant="outlined"
          value={fieldData?.field2}
          onChange={handleChange}
    
        />
        <br />
        <span
          style={{
            color: "#3E4A62",
            fontSize: "14px",
            fontWeight: "500",
            marginTop: "5px",
            marginBottom: "5px",
            display:getOrgType()  != "Admin"?"none":""
          }}
      
        >
          Email
        </span>
        <br />
        <TextField
          name="field3"
          sx={{ width: "281px", display:getOrgType() != "Admin"?"none":"" }}
          size="small"
          variant="outlined"
          value={fieldData?.field3}
          onChange={handleChange}
       
        />

        <br />
        <span
          style={{
            color: "#3E4A62",
            fontSize: "14px",
            fontWeight: "500",
            marginTop: "5px",
            marginBottom: "5px",
            display:getOrgType()  != "Admin"?"none":""
          }}
      
        >
          Title
        </span>
        <br />
        <TextField
          name="title"
          sx={{ width: "281px" }}
          size="small"
          variant="outlined"
          value={fieldData?.title}
          onChange={handleChange}
      
          style={{  display:getOrgType()  != "Admin"?"none":""}}
        />
</div>
        {data?.map((item, index) => (
          <div key={item?.empQuizCategoryId}>
            <span
              style={{
                color: "#3E4A62",
                fontSize: "14px",
                fontWeight: "500",
                marginTop: "5px",
                marginBottom: "5px",
              }}
            >
              {item?.categoryName}
            </span>
            <br />
            <Select
              size="small"
              sx={{ width: "281px" }}
              value={item?.subCategorySelectedValue}
              onChange={(event) =>
                handleSubCategoryChange(
                  event,
                  index,
                  "subCategorySelectedValue"
                )
              }
            >
              {item?.subCategoriesValue?.split("|")?.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
            <br />
            {item?.subCategorySelectedValue !== "N/A" &&
              item?.subCategorySelectedValue !== null && (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={item?.subCategoryEnteredDate}
                    defaultValue={item?.defaultDate}
                    onChange={(date) =>
                      handleSubCategoryChange(
                        { target: { value: date } },
                        index,
                        "subCategoryEnteredDate"
                      )
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        sx={{ width: "281px", marginTop: "10px" }}
                        size="small"
                        error={
                          item?.subCategoryEnteredDate === null &&
                          item?.subCategorySelectedValue !== "N/A"
                        }
                        helperText={
                          item?.subCategoryEnteredDate === null &&
                            item?.subCategorySelectedValue !== "N/A"
                            ? "Date is required"
                            : ""
                        }
                      />
                    )}
                  />
                </LocalizationProvider>
              )}
          </div>
        ))}
        <br />
        <DialogActions>
          <div className="login-help__buttonContainer">
            <Button
              variant="contained"
              className="login-help-button-cancel"
              onClick={close}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              className="login-button-request"
              onClick={Save}
            >
              Save
            </Button>
          </div>
        </DialogActions>
      </DialogContent>
    </>
  );
}
